import type { AxiosResponse } from 'axios';

export async function runtimeValidate(response: AxiosResponse) {
  if (!response.config.schema) {
    return response;
  }

  const parsed = await response.config.schema.safeParseAsync(response.data);

  if (!parsed.success) {
    // TODO: better to capture via the Sentry captureException method
    console.error(parsed.error);
  }

  return response;
}
